export const home_overview = '/v1/oauth/aG9tZV9vdmVydmlldw==';
export const home_overview_new = '/v1/oauth/home_overview';
